
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop } from "vue-property-decorator";
import BgAvatarUploader from "@/components/bg-avatar-uploader/index.vue";
// import { ElementUIFormRules } from "@/service/supplier-meta/common/supplier-field-ctrl";
// import { Form } from "element-ui";
import { SupplierInfoSubmitBO } from "@/service/supplier-meta/entity/SupplierInfoSubmitBO";
import { stopSaving, removeCache } from "../../common/cache.mixin";
@Component({
  components: {
    BgAvatarUploader,
  },
})
export default class joinUsSuccess extends Vue {
  /** 提交的数据 */
  @Prop() submitData!: SupplierInfoSubmitBO;
  get email() {
    return this.submitData?.linkmanInfo?.email || "";
  }
  sure() {
    this.$emit("cancel");
  }
  created() {
    stopSaving();
    removeCache();
  }
}
